export interface GuardedStep {
  label: string;
  run: () => Promise<void> | void;
}

/**
 * Exécute les étapes de chargement d'un écran l'une après l'autre ; une étape qui échoue est signalée
 * (libellé + cause) mais n'empêche PAS les suivantes. Retourne les libellés des étapes en échec.
 */
export async function runGuardedSteps(
  steps: readonly GuardedStep[],
  onFailure: (label: string, error: unknown) => void,
): Promise<string[]> {
  const failed: string[] = [];
  for (const step of steps) {
    try {
      await step.run();
    } catch (error) {
      failed.push(step.label);
      onFailure(step.label, error);
    }
  }
  return failed;
}
